export const SHEPHERD_NEXT_BUTTON_CLASSES =
  'assign-btn mdc-button mdc-button--raised mat-mdc-raised-button mat-primary mat-mdc-button-base vi-button';
export const SHEPHERD_PREVIOUS_BUTTON_CLASSES =
  'mdc-button mdc-button--outlined mat-mdc-outlined-button mat-unthemed mat-mdc-button-base vi-button ng-star-inserted';

export const SHEPHERD_SMALL_SCREEN_SIZE_BREAKPOINT = 576;
